"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWorkingDayTime_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserWorkingDay_1 = require("./UserWorkingDay");
var UserWorkingDayTime_Factory = /** @class */ (function () {
    function UserWorkingDayTime_Factory() {
    }
    UserWorkingDayTime_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            EndTime: Date_Factory_1.Date_Factory.CreateIncoming(model.EndTime),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StartTime: Date_Factory_1.Date_Factory.CreateIncoming(model.StartTime),
            UserWorkingDay: UserWorkingDay_1.UserWorkingDay_Factory.CreateIncoming(model.UserWorkingDay),
            UserWorkingDayId: model.UserWorkingDayId,
        };
        return result;
    };
    UserWorkingDayTime_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            EndTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.EndTime),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StartTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartTime),
            UserWorkingDay: UserWorkingDay_1.UserWorkingDay_Factory.CreateOutgoing(model.UserWorkingDay),
            UserWorkingDayId: model.UserWorkingDayId,
        };
        return result;
    };
    return UserWorkingDayTime_Factory;
}());
exports.UserWorkingDayTime_Factory = UserWorkingDayTime_Factory;
